module.exports = __webpack_public_path__ + "static/media/36_tn.7205f687.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/36_tn.jpg
// module id = 249
// module chunks = 0